import { getScanbotSdk } from '~/lib/scanbot-client';
import { Page } from '../_screens/ScreenController';

/**
 * Generates a PDF from an array of pages.
 *
 * @param pages - An array of page objects from ScanSDK
 */
export const generatePdfBlobFromScannedDocuments = async (
  pages: Page[]
): Promise<Blob> => {
  // Initialize the Scanbot SDK and start a new PDF with the desired options.
  const sdk = await getScanbotSdk();
  const generator = await sdk.beginPdf({
    pageSize: 'A4',
    pageDirection: 'PORTRAIT',
    pageFit: 'FIT_IN',
    dpi: 72,
    jpegQuality: 80,
    resamplingMethod: 'NONE'
  });

  // Process each page and add it to the PDF generator.
  for (const page of pages) {
    await generator.addPage(page.capture);
  }

  const pdfContents = await generator.complete();
  const blob = new Blob([pdfContents], { type: `application/pdf` });
  return blob;
};
